export const IPO_STATUS_FILTERS = [
  { label: 'All', value: null },
  { label: 'Active', value: 'Active' },
  { label: 'Forthcoming', value: 'Forthcoming' },
  { label: 'Listed', value: 'Listed' },
  { label: 'Closed', value: 'Closed' },
];

export const IPO_SESSION_CACHE_PREFIX = 'iposData_v2';
